import React, { Component, Fragment } from "react";
import marketStyle from "../css/marketsBaseball.css";
import OddsCardBaseball from "./oddsCardBaseball";

class CorrectScore extends Component {
  render() {
    let store = this.props.store;
    let markets = this.props.markets;
    let correctScoreMarkets = [];
    let storeData = store.getState();

    let winMarket = [];
    let drawMarket = [];
    let looseMarket = [];
    markets.forEach((market) => {
      let arr = market.selection.split("-");
      if (arr[0] > arr[1]) {
        winMarket.push(market);
      } else if (arr[0] < arr[1]) {
        looseMarket.push(market);
      } else {
        drawMarket.push(market);
      }
    });

    for (let i = 0; i < 15; i++) {
      let drawMarketTemp = "";
      if (drawMarket[i]) {
        drawMarketTemp = (
          <div className={`${marketStyle.scoreGroupSmall}`}>
            <div
              className={`${marketStyle.marketLabelSmall} ${marketStyle.marketLabel}`}
            >
              <span>{drawMarket[i].selection}</span>
            </div>
            <div className={marketStyle.oddsContainerSmall}>
              <OddsCardBaseball store={store} market={drawMarket[i]} />
            </div>
          </div>
        );
      } else {
        drawMarketTemp = (
          <div className={`${marketStyle.scoreGroupSmall}`}>
            {<OddsCardBaseball store={store} market={"empty"} />}
          </div>
        );
      }
      correctScoreMarkets.push(
        <Fragment key={i}>
          <div className={`${marketStyle.scoreGroupSmall}`}>
            <div
              className={`${marketStyle.marketLabelSmall} ${marketStyle.marketLabel}`}
            >
              <span>{winMarket[i].selection}</span>
            </div>
            <div className={marketStyle.oddsContainerSmall}>
              <OddsCardBaseball store={store} market={winMarket[i]} />
            </div>
          </div>
          {drawMarketTemp}
          <div className={`${marketStyle.scoreGroupSmall}`}>
            <div
              className={`${marketStyle.marketLabelSmall} ${marketStyle.marketLabel}`}
            >
              <span>{looseMarket[i].selection}</span>
            </div>
            <div className={marketStyle.oddsContainerSmall}>
              <OddsCardBaseball store={store} market={looseMarket[i]} />
            </div>
          </div>
        </Fragment>
      );
    }

    return (
      <div
        className={`${marketStyle.marketGroup} ${marketStyle.marketAlignFlex}`}
      >
        {correctScoreMarkets}
      </div>
    );
  }
}

export default CorrectScore;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/baseball/components/correctScore.js